import React from 'react';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  text-align: center;
  padding: 3rem 0;
  color: ${props => props.theme.colors.text.secondary};
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 3rem 0;
  color: ${props => props.theme.colors.text.secondary};

  h3 {
    margin-bottom: 1rem;
    color: ${props => props.theme.colors.text.primary};
  }
`;

export const LoadingState = ({ message = "Loading..." }) => {
  return (
    <LoadingContainer>
      <p>{message}</p>
    </LoadingContainer>
  );
};

export const EmptyContentState = ({ title = "No content found", message = "Try adjusting your search terms or filters" }) => {
  return (
    <EmptyState>
      <h3>{title}</h3>
      <p>{message}</p>
    </EmptyState>
  );
};